module.exports = __webpack_public_path__ + "static/media/food_stamps.333fc495.png";